import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import closeIcon from "src/Assets/images/Add.png";
import feedstyles from "src/Assets/css/home/feedpost.module.css";

const ModeratorBlogReusableAlertPopup = ({
  open,
  title,
  message,
  onClose,
  onContinue,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="moderator-blog-popup-title"
      sx={{
        zIndex: 2000,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#fff",
          borderRadius: "12px",
          outline: "none",
          boxShadow: 24,
          width: 420,
          maxWidth: "90%",
          padding: "24px",
        }}
      >
        {/* Popup Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <h3
            id="moderator-blog-popup-title"
            style={{
              margin: 0,
              fontSize: "18px",
              fontWeight: 600,
            }}
          >
            {title}
          </h3>

          <img
            src={closeIcon}
            alt="Close"
            onClick={onClose}
            style={{
              width: 18,
              height: 18,
              cursor: "pointer",
            }}
          />
        </div>

        {/* Popup Message */}
        <p
          style={{
            margin: "0 0 24px",
            fontSize: "14px",
            lineHeight: "22px",
            color: "#555",
          }}
        >
          {message}
        </p>

        {/* Footer Actions */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "25px",
          }}
        >
          <button
            type="button"
            onClick={onClose}
            style={{
              background: "transparent",
              border: "1px solid #d9d9d9",
              borderRadius: "6px",
              padding: "8px 20px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={onContinue}
            style={{
              background: "#1976d2",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              padding: "8px 20px",
              cursor: "pointer",
            }}
          >
            Continue
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default ModeratorBlogReusableAlertPopup;